import script from "./StartWhatsAppChatModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartWhatsAppChatModal.vue?vue&type=script&setup=true&lang=ts"

import "./StartWhatsAppChatModal.vue?vue&type=style&index=0&id=7121842c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7121842c"]])

export default __exports__